import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill"
import Circle from "ol/style/Circle"
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';

function twoColorStyle(outerColor,innerColor)   {
	var styleCache = {};
	styleCache.polygon = [
		
		new Style({
	        stroke: new Stroke({
	          color: outerColor,
	          width: 6
	        }),
	        fill: new Fill({
	        	color:'rgba(255, 255, 255, 0.2)'
	        })
	      }),
	      new Style({
		        stroke: new Stroke({
		          color: innerColor,
		          width: 2
		        })
		      })
	]
	styleCache.point = [
		new Style({
			image : new Circle({
	            radius : 6,
	            fill : new Fill({
	              color : outerColor
	            })
	          }),
	          geometry : function (feature) {
		             
	                return feature.getGeometry().getInteriorPoints()
	              
	              
	            }
	      }),
	      new Style({
	    	  image : new Circle({
		            radius : 3,
		            fill : new Fill({
		              color : innerColor
		            })
		          }),
		      
		      geometry : function (feature) {
	             
	                return feature.getGeometry().getInteriorPoints()
	              
	              
	            }
	      })
	]
	
	var styleFunction = function(feature,resolution) {
		if(resolution < 20) {
			return styleCache.polygon;
		}else {
			return styleCache.point;
		}
		
	}
	return styleFunction;
}
function highliteStyle() {
    var parcelHighliteStyle = new Style({
                    image: new Icon({
                      anchorXUnits: 'fraction',
                      anchorYUnits: 'fraction',
                      anchor:[0.5,1],
                        scale:0.5,
                      src: contextPath+"/resources/images/locationRed.png"
                    }),
                    geometry : function (feature) {
                        if(typeof(feature.getGeometry().getInteriorPoints) === "function") {
                            return feature.getGeometry().getInteriorPoints();
                        }else {
                            return feature.getGeometry();
                        }
	                   
	               }
               })
    return parcelHighliteStyle;
    
}
function selectParcelStyle() {
    var styleCache={};
    styleCache.big = [new Style({
			image : new Circle({
	            radius : 16,
	            fill : new Fill({
	              color: "rgba(255,0,0,0.7)"
	            })
	          }),
	          geometry : function (feature) {
  
	               return feature.getGeometry().getInteriorPoints()
	            }
    })];
    styleCache.small = [new Style({
	        stroke: new Stroke({
	          color: "red",
	          width: 6
	        })
	      })];
    
    var selectStyleFunc = function(feature,resolution) {
        if(resolution < 20) {
			return styleCache.small;
		}else {
			return styleCache.big;
		}
    }
    return selectStyleFunc;
}





export default {
    twoColorStyle:twoColorStyle,
    selectParcelStyle:selectParcelStyle,
    highliteStyle:highliteStyle
}
